import { Validator } from '@vista-digital/validator';
import { defaultMemberCardCdnOptions, memberCardCdnOptionsValidator } from '../../card/types/cdn-options';
import { defaultMemberViewCardButtonConfig, memberViewCardButtonConfigValidator } from './config';
import { defaultMemberViewCardButtonDisplayText, memberViewCardButtonDisplayTextValidator } from './display-text';
export const defaultMemberViewCardButtonProps = {
    config: defaultMemberViewCardButtonConfig,
    displayText: defaultMemberViewCardButtonDisplayText,
    cdnOptions: defaultMemberCardCdnOptions
};
export const memberViewCardButtonPropsValidator = Validator.object({
    config: memberViewCardButtonConfigValidator,
    displayText: memberViewCardButtonDisplayTextValidator,
    cdnOptions: memberCardCdnOptionsValidator
});
